import { render, staticRenderFns } from "./historialPedidos.vue?vue&type=template&id=83965b12&scoped=true"
import script from "./historialPedidos.vue?vue&type=script&lang=js"
export * from "./historialPedidos.vue?vue&type=script&lang=js"
import style0 from "./historialPedidos.vue?vue&type=style&index=0&id=83965b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83965b12",
  null
  
)

export default component.exports